// extracted by mini-css-extract-plugin
export default {"form":"ProductForm_form__wE0ub"};